import { Component, OnDestroy, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
// import { Subscription } from 'rxjs';
// import { NewsService } from 'src/app/services/news/news.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit, OnDestroy {
customOptions: OwlOptions = {
  loop: true,
  mouseDrag: true,
  touchDrag: true,
  pullDrag: true,
  dots: false,
  margin: 10,
  navSpeed: 700,
  navText: ['<', '>'],
  responsive: {
    0: { items: 1 },
    400: { items: 3 },
    740: { items: 3 },
    940: { items: 4 }
  },
  nav: true
};

news: {imgUrl: string, type: string, title: string}[] = [
  {
    imgUrl:'/assets/img/news/11.jpg',
    type:'NEWS & EVENTS',
    title:'Code To Market: Turning algorithm into impactful products'
  },
  {
    imgUrl:'/assets/img/news/1.jpg',
    type:'NEWS & EVENTS',
    title:'Congratulations Students!! for your Campus Placement in Munjal Kiriu Industries Pvt. Ltd., Gurugram'
  },
  {
    imgUrl:'/assets/img/news/2.jpg',
    type:'NEWS & EVENTS',
    title:'Expert Lecture on "Practical Aspects of Power System"'
  },
  {
    imgUrl:'/assets/img/news/3.jpg',
    type:'NEWS & EVENTS',
    title:'EXPERT LECTURE ON ACHIEVING "VALUE PROPOSITION FIT" & "BUSINESS FIT"'
  },
  {
    imgUrl:'/assets/img/news/4.jpeg',
    type:'NEWS & EVENTS',
    title:'Admissions Open Against VACANT/LEFT OVER SEATS'
  },
  {
    imgUrl:'/assets/img/news/5.jpg',
    type:'NEWS & EVENTS',
    title:'ANTI RAGGING WEEK CELEBRATION'
  },
  {
    imgUrl:'/assets/img/news/6.jpg',
    type:'NEWS & EVENTS',
    title:'WELCOMES First Year BCA Students for INDUCTION PROGRAMME-2024'
  },
  {
    imgUrl:'/assets/img/news/7.jpg',
    type:'NEWS & EVENTS',
    title:'"Independence Day - Celebrating Azadi Ka Amritkal"'
  },
  {
    imgUrl:'/assets/img/news/8.jpg',
    type:'NEWS & EVENTS',
    title:'Session on "Lean Start-up & Minimum Viable Product/Business" - Boot camp'
  },
  {
    imgUrl:'/assets/img/news/9.jpg',
    type:'NEWS & EVENTS',
    title:'EXPERT LECTURE ON Accelerators/Incubation Opportunities for students & Faculties'
  },
  {
    imgUrl:'/assets/img/news/10.jpg',
    type:'NEWS & EVENTS',
    title:'EXPERT LECTURE ON REMEDIAL EDUCATION by Dr. S. K. Aggarwal'
  },
];

// ✅ backend vars removed
// newsList: any[] = [];
// sub: Subscription;

// ✅ service removed
// constructor(private newsService: NewsService) { }
constructor() {}

ngOnInit(): void {
  // ❌ Removing backend calls
  // this.newsService.getNewsList();
  // this.sub = this.newsService.newsList.snapshotChanges().subscribe(...);
}

ngOnDestroy() {
  // ❌ unsub not needed
  // this.sub.unsubscribe();
}

}
